import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  'attendance.new': 'New',
  'attendance.edit': 'Edit',
  'attendance.delete': 'Delete',
  'attendance.title': 'Attendance Records',
  'attendance.ID': 'ID',
  'attendance.staffId': 'Staff ID',
  'attendance.staff': 'Staff',
  'attendance.pleaseSelectAttendanceType': 'Please select attendance type',
  'attendance.attendanceTypePlaceholder': 'Select attendance type',
  'attendance.timestamp': 'Timestamp',
  'attendance.torranceMinutes': 'Torrance Minutes',
  'attendance.expectedTime': 'Expected Time',
  'attendance.site': 'Site',
  'attendance.shift': 'Shift',
  'attendance.checkpoint': 'Checkpoint',
  'attendance.requireOB': 'Require OB Number',
  'attendance.createdAt': 'Created At',
  'attendance.updatedAt': 'Updated At',
  'attendance.actions': 'Actions',
  'attendance.createAttendance': 'Create Attendance',
  'attendance.editAttendance': 'Edit Attendance',
  'attendance.cancel': 'Cancel',
  'attendance.create': 'Create',
  'attendance.update': 'Update',
  'attendance.deleted': 'Attendance deleted',
  'attendance.deleteFailed': 'Failed to delete attendance',
  'attendance.created': 'Attendance created',
  'attendance.updated': 'Attendance updated',
  'attendance.saveFailed': 'Failed to save attendance',
  'attendance.deleteConfirm': 'Are you sure to delete this attendance?',
  'attendance.yes': 'Yes',
  'attendance.no': 'No',
  'attendance.pleaseSelectStaff': 'Please select staff',
  'attendance.pleaseSelectSite': 'Please select site',
  'attendance.pleaseSelectShift': 'Please select shift',
  'attendance.pleaseSelectCheckpoint': 'Please select checkpoint',
  'attendance.pleaseInputShiftAssignmentId': 'Please input shift assignment id',
  'attendance.pleaseSelectTimestamp': 'Please select timestamp',
  'attendance.latitude': 'Latitude',
  'attendance.longitude': 'Longitude',
  'attendance.ip': 'IP Address',
  'attendance.latitudeNumber': 'Latitude must be a number',
  'attendance.longitudeNumber': 'Longitude must be a number',
  'attendance.latitudePlaceholder': 'Latitude (optional)',
  'attendance.longitudePlaceholder': 'Longitude (optional)',
  'attendance.ipPlaceholder': 'IP Address (optional)',
  'attendance.shiftAssignmentId': 'Shift Assignment ID',
  'attendance.approvalStatus': 'Approval Status',
  'attendance.approved': 'Approved',
  'attendance.rejected': 'Rejected',
  'attendance.pending': 'Pending',
  'attendance.approvedBy': 'Approved By',
  'attendance.remark': 'Remark',
  'attendance.approve': 'Approve',
  'attendance.reject': 'Reject',
  'attendance.approvalTitle': 'Approve/Reject Attendance',
  'attendance.approvalDecision': 'Approval Decision',
  'attendance.pleaseSelectApprovalDecision': 'Please select approval decision',
  'attendance.remarkPlaceholder': 'Optional remark for the approval decision',
  'attendance.submit': 'Submit',
  'attendance.approvalSuccess': 'Attendance approval status updated successfully',
  'attendance.approvalFailed': 'Failed to update attendance approval status',
  'attendance.patrol': 'Patrol',
  'userManagement.showing': 'Showing',
  'userManagement.of': 'of',
  'userManagement.items': 'items',
  'checkpoint.create': 'Create Checkpoint',
  'checkpoint.edit': 'Edit Checkpoint',
  'checkpoint.name': 'Name',
  'checkpoint.description': 'Description',
  'checkpoint.referenceCode': 'Reference Code',
  'checkpoint.active': 'Active',
  'checkpoint.cancel': 'Cancel',
  'checkpoint.pleaseInputName': 'Please input checkpoint name',
  'checkpoint.pleaseInputReferenceCode': 'Please input reference code',
  'checkpoint.update': 'Update',
  'incident.type.incident': 'Incident',
  'incident.type.maintenance': 'Maintenance',
  'incident.type.general': 'General',
  'incident.type.complain': 'Complain',
  'attendance.showing': 'Showing',
  'attendance.of': 'of',
  'attendance.items': 'items',
  'incident.status.open': 'Open',
  'incident.status.assigned': 'Assigned',
  'incident.status.inProgress': 'In Progress',
  'incident.status.reviewing': 'Reviewing',
  'incident.status.resolved': 'Resolved',
  'incident.status.closed': 'Closed',
  'incident.severity.low': 'Low',
  'incident.severity.medium': 'Medium',
  'incident.severity.high': 'High',
  'incident.severity.critical': 'Critical',
  'incident.create.success': 'Incident created successfully',
  'incident.create.failed': 'Failed to create incident',
  'incident.management': 'Incident Management',
  'incident.kanban': 'Kanban',
  'incident.calendar': 'Calendar',
  'incident.addIncident': 'Add Incident',
  'incident.selectSite': 'Select Site',
  'incident.type': 'Type',
  'incident.status': 'Status',
  'incident.severity': 'Severity',
  'incident.selectSitePrompt': 'Please select a site to view logs in Kanban or Calendar view.',
  'incident.addNewIncident': 'Add New Incident',
  'incident.create': 'Create',
  'incident.logType': 'Log Type',
  'incident.pleaseSelectLogType': 'Please select log type',
  'incident.selectLogType': 'Select log type',
  'incident.title': 'Title',
  'incident.pleaseEnterTitle': 'Please enter title',
  'incident.enterTitle': 'Enter title',
  'incident.description': 'Description',
  'incident.pleaseEnterDescription': 'Please enter description',
  'incident.enterDescription': 'Enter description',
  'incident.pleaseSelectSeverity': 'Please select severity',
  'incident.selectSeverity': 'Select severity',
  'incident.attachments': 'Attachments (optional)',
  'incident.selectFiles': 'Select Files',
  'incident.updateStatus': 'Update Status',
  'incident.newState': 'New State',
  'incident.pleaseSelectNewState': 'Please select new state',
  'incident.assignTo': 'Assign To',
  'incident.pleaseSelectStaffToAssign': 'Please select staff to assign',
  'incident.notes': 'Notes',
  'incident.pleaseEnterNotes': 'Please enter notes',
  'incident.logDetails': 'Log Details',
  'incident.currentState': 'Current State',
  'incident.loggedBy': 'Logged By',
  'incident.createdAt': 'Created At',
  'incident.stateChanges': 'State Changes',
  'incident.changedStateFromTo': 'Changed state from {from} to {to}',
  'incident.assignedTo': 'Assigned to: {name}',
  'incident.responses': 'Responses',
  'incident.edit': 'Edit',
  'incident.pleaseEnterResponse': 'Please enter a response',
  'incident.addResponsePlaceholder': 'Add a response...',
  'incident.updateResponse': 'Update Response',
  'incident.addResponse': 'Add Response',
  'incident.cancel': 'Cancel',
  'shiftAssignment.siteShift': 'Site - Shift',
  'shiftAssignment.assigned': 'Assigned',
  'shiftAssignment.noSites': 'No sites found',
  'shiftAssignment.selectRegionDistrict': 'Please select both region and district',
  'shiftAssignment.filterByRegion': 'Filter by Region',
  'shiftAssignment.filterByDistrict': 'Filter by District',
  'shiftAssignment.monthPicker': 'Select Month',
  'shiftAssignment.importExcel': 'Import Excel',
  'shiftAssignment.import': 'Import',
  'shiftAssignment.selectFile': 'Select Excel File',
  'shiftAssignment.fileRequirements': 'Support .xlsx and .xls files, max 10MB',
  'shiftAssignment.importSuccess': 'Import completed successfully',
  'shiftAssignment.importWithConflicts': 'Import completed with conflicts',
  'shiftAssignment.importError': 'Import failed',
  'shiftAssignment.invalidFileType': 'You can only upload Excel files!',
  'shiftAssignment.fileTooLarge': 'File must be smaller than 10MB!',
  'shiftAssignment.noFileSelected': 'Please select a file to import',
  'shiftAssignment.importResult': 'Import Result',
  'shiftAssignment.totalAssignments': 'Total Assignments',
  'shiftAssignment.createdAssignments': 'Created Assignments',
  'shiftAssignment.skippedAssignments': 'Skipped Assignments',
  'shiftAssignment.conflicts': 'Conflicts',
  'shiftAssignment.conflictDetails': 'Conflict Details',
  'shiftAssignment.legend': 'Legend',
  'shiftAssignment.sunday': 'SUN',
  'shiftAssignment.holiday': 'HOL',
  'shiftAssignment.holidayName': 'Holiday Name',
  'shiftAssignment.originalName': 'Original name',
  // Region translations
  'region.hongKong': 'Hong Kong',
  'region.kowloon': 'Kowloon',
  'region.newTerritories': 'New Territories',
  // District translations
  'district.centralAndWestern': 'Central and Western',
  'district.wanChai': 'Wan Chai',
  'district.eastern': 'Eastern',
  'district.southern': 'Southern',
  'district.yauTsimMong': 'Yau Tsim Mong',
  'district.shamShuiPo': 'Sham Shui Po',
  'district.kowloonCity': 'Kowloon City',
  'district.wongTaiSin': 'Wong Tai Sin',
  'district.kwunTong': 'Kwun Tong',
  'district.tuenMun': 'Tuen Mun',
  'district.yuenLong': 'Yuen Long',
  'district.north': 'North',
  'district.taiPo': 'Tai Po',
  'district.saiKung': 'Sai Kung',
  'district.shaTin': 'Sha Tin',
  'district.kwaiTsing': 'Kwai Tsing',
  'district.tsuenWan': 'Tsuen Wan',
  'district.islands': 'Islands',
  'shiftDetail.staff': 'Staff',
  'shiftDetail.notMapped': 'Not Mapped',
  'shiftDetail.employeeId': 'Employee ID',
  'shiftDetail.title': 'Title',
  'shiftDetail.phone': 'Phone',
  'shiftDetail.overnight': 'Overnight',
  'shiftDetail.dayShift': 'Day Shift',
  'shiftDetail.manageStaff': 'Manage Staff',
  'shiftDetail.noStaffMapped': 'No staff mapped to this shift',
  'shiftDetail.assignToThisShift': 'Assign to this shift',
  'shiftDetail.assignToOtherShift': 'Assign to other shift',
  'shiftDetail.markAsLeave': 'Mark as leave',
  'shiftDetail.removeAssignment': 'Remove Assignment',
  'shiftDetail.removeAssignmentConfirm': 'Are you sure you want to remove this assignment?',
  'shiftDetail.cancelLeave': 'Cancel Leave',
  'shiftDetail.cancelLeaveConfirm': 'Are you sure you want to cancel this leave?',
  'shiftDetail.yes': 'Yes',
  'shiftDetail.no': 'No',
  'shiftDetail.assignShift': 'Assign Shift',
  'shiftDetail.assignToOtherShiftTitle': 'Assign to Other Shift',
  'shiftDetail.confirmShiftAssignment': 'Confirm shift assignment?',
  'shiftDetail.addLeave': 'Add Leave',
  'shiftDetail.annualLeave': 'Annual Leave',
  'shiftDetail.sickLeave': 'Sick Leave',
  'shiftDetail.personalLeave': 'Personal Leave',
  'shiftDetail.leaveReason': 'Leave reason',
  'shiftDetail.leaveAdded': 'Leave added successfully',
  'shiftDetail.leaveAddFailed': 'Failed to add leave',
  'shiftDetail.assignmentCreated': 'Assignment created successfully',
  'shiftDetail.assignmentCreateFailed': 'Failed to create assignment',
  'shiftDetail.assignmentDeleted': 'Assignment deleted successfully',
  'shiftDetail.assignmentDeleteFailed': 'Failed to delete assignment',
  'shiftDetail.leaveCancelled': 'Leave cancelled successfully',
  'shiftDetail.leaveCancelFailed': 'Failed to cancel leave',
  'shiftDetail.currentStaff': 'Current Staff',
  'shiftDetail.name': 'Name',
  'shiftDetail.action': 'Action',
  'shiftDetail.remove': 'Remove',
  'shiftDetail.addStaff': 'Add Staff',
  'shiftDetail.selectStaffToAdd': 'Select staff to add',
  'shiftDetail.fetchStaffFailed': 'Failed to fetch available staff',
  'shiftDetail.staffMapped': 'Staff mapped successfully',
  'shiftDetail.staffMapFailed': 'Failed to map staff',
  'shiftDetail.staffRemoved': 'Staff removed successfully',
  'shiftDetail.staffRemoveFailed': 'Failed to remove staff',
  'shiftDetail.fillAllFields': 'Please fill in all required fields',
  'shiftDetail.selectSiteAndShift': 'Select site and shift:',
  'shiftDetail.selectSite': 'Select site',
  'shiftDetail.selectShift': 'Select shift',
  'menu.admin.asset-management': 'Asset Management',
  'siteDetail.title': 'Site Detail',
  'siteDetail.siteInformationTitle': 'Site Information',
  'siteDetail.name': 'Name',
  'siteDetail.shortName': 'Short Name',
  'siteDetail.address': 'Address',
  'siteDetail.district': 'District',
  'siteDetail.region': 'Region',
  'siteDetail.status': 'Status',
  'siteDetail.active': 'Active',
  'siteDetail.inactive': 'Inactive',
  'siteDetail.basicInformation': 'Basic Information',
  'siteDetail.siteID': 'Site ID',
  'siteDetail.unitsTitle': 'Units',
  'siteDetail.addUnit': 'Add Unit',
  'siteDetail.editUnit': 'Edit Unit',
  'siteDetail.deleteUnit': 'Delete Unit',
  'siteDetail.unitNumber': 'Unit Number',
  'siteDetail.occupied': 'Occupied',
  'siteDetail.vacant': 'Vacant',
  'siteDetail.occupiedLabel': 'Occupied',
  'siteDetail.vacantLabel': 'Vacant',
  'siteDetail.action': 'Action',
  'siteDetail.edit': 'Edit',
  'siteDetail.delete': 'Delete',
  'siteDetail.addShift': 'Add Shift',
  'siteDetail.shiftsTitle': 'Shifts',
  'siteDetail.shiftName': 'Shift Name',
  'siteDetail.time': 'Time',
  'siteDetail.overnight': 'Overnight',
  'siteDetail.overnightShift': 'Overnight Shift',
  'siteDetail.requiredHeadcount': 'Required Headcount',
  'siteDetail.headcount': 'Headcount',
  'siteDetail.assignedStaff': 'Assigned Staff',
  'siteDetail.manageStaff': 'Manage Staff',
  'siteDetail.manageShifts': 'Manage Shifts',
  'siteDetail.shiftUpdatedSuccess': 'Shift updated successfully',
  'siteDetail.shiftCreatedSuccess': 'Shift created successfully',
  'siteDetail.operationFailed': 'Operation failed',
  'siteDetail.checkpointManagementTitle': 'Checkpoint Management',
  'siteDetail.addCheckpoint': 'Add Checkpoint',
  'siteDetail.referenceCode': 'Reference Code',
  'siteDetail.requireObNumber': 'Require OB Number',
  'siteDetail.description': 'Description',
  'siteDetail.activeLabel': 'Active',
  'siteDetail.inactiveLabel': 'Inactive',
  'siteDetail.checkpointCreated': 'Checkpoint created successfully',
  'siteDetail.checkpointUpdated': 'Checkpoint updated successfully',
  'siteDetail.checkpointSaveFailed': 'Failed to save checkpoint',
  'siteDetail.contactNumbersTitle': 'Contact Numbers',
  'siteDetail.addPhone': 'Add Phone',
  'siteDetail.phoneNumber': 'Phone Number',
  'siteDetail.phoneAddedSuccess': 'Phone added successfully',
  'siteDetail.phoneUpdatedSuccess': 'Phone updated successfully',
  'siteDetail.phoneDeletedSuccess': 'Phone deleted successfully',
  'siteDetail.fetchSiteDetailsError': 'Failed to fetch site details',
  'siteDetail.fetchUnitsError': 'Failed to fetch units',
  'siteDetail.fetchLogsError': 'Failed to fetch logs',
  'siteDetail.logCreatedSuccess': 'Log created successfully',
  'siteDetail.logUpdatedSuccess': 'Log updated successfully',
  'siteDetail.logResolveFailed': 'Failed to resolve log',
  'siteDetail.logResolvedSuccess': 'Log resolved successfully',
  'siteDetail.unitCreatedSuccess': 'Unit created successfully',
  'siteDetail.unitUpdatedSuccess': 'Unit updated successfully',
  'siteDetail.unitDeletedSuccess': 'Unit deleted successfully',
  'siteDetail.unitSaveFailed': 'Failed to save unit',
  'siteDetail.unitDeleteFailed': 'Failed to delete unit',
  'siteDetail.addLog': 'Add Log',
  'siteDetail.recentLogsTitle': 'Recent Logs',
  'siteDetail.logType': 'Log Type',
  'siteDetail.incident': 'Incident',
  'siteDetail.maintenance': 'Maintenance',
  'siteDetail.general': 'General',
  'siteDetail.complain': 'Complain',
  'siteDetail.severity': 'Severity',
  'siteDetail.low': 'Low',
  'siteDetail.medium': 'Medium',
  'siteDetail.high': 'High',
  'siteDetail.critical': 'Critical',
  'siteDetail.status': 'Status',
  'siteDetail.open': 'Open',
  'siteDetail.inProgress': 'In Progress',
  'siteDetail.resolved': 'Resolved',
  'siteDetail.closed': 'Closed',
  'siteDetail.createdBy': 'Created By',
  'siteDetail.createdAt': 'Created At',
  'siteDetail.resolution': 'Resolution',
  'siteDetail.resolvedBy': 'Resolved By',
  'siteDetail.resolvedAt': 'Resolved At',
  'siteDetail.viewDetails': 'View Details',
  'siteDetail.updateStatus': 'Update Status',
  'siteDetail.logDetailsTitle': 'Log Details - {title}',
  'siteDetail.currentState': 'Current State',
  'siteDetail.loggedBy': 'Logged By',
  'siteDetail.stateChanges': 'State Changes',
  'siteDetail.changedStateFrom': 'Changed state from',
  'siteDetail.to': 'to',
  'siteDetail.assignedTo': 'Assigned To',
  'siteDetail.responses': 'Responses',
  'siteDetail.addResponse': 'Add Response',
  'siteDetail.updateResponse': 'Update Response',
  'siteDetail.cancel': 'Cancel',
  'siteDetail.pleaseEnterResponse': 'Please enter a response',
  'siteDetail.responseAddedSuccess': 'Response added successfully',
  'siteDetail.responseAddFailed': 'Failed to add response',
  'siteDetail.responseUpdatedSuccess': 'Response updated successfully',
  'siteDetail.responseUpdateFailed': 'Failed to update response',
  'siteDetail.manageShiftPreferencesTitle': 'Manage Shift Preferences - {employee_id}',
  'siteDetail.preferredShifts': 'Preferred Shifts',
  'siteDetail.selectShifts': 'Select shifts',
  'siteDetail.currentPreferences': 'Current Preferences',
  'siteDetail.remove': 'Remove',
  'siteDetail.preferencesUpdatedSuccess': 'Preferences updated successfully',
  'siteDetail.preferencesUpdateFailed': 'Failed to update preferences',
  'siteDetail.preferenceRemovedSuccess': 'Preference removed successfully',
  'siteDetail.preferenceRemoveFailed': 'Failed to remove preference',
  'siteDetail.fetchPreferencesError': 'Failed to fetch preferences',
  'siteDetail.manageStaffTitle': 'Manage Staff - {name}',
  'siteDetail.assignStaff': 'Assign Staff',
  'siteDetail.assignStaffTitle': 'Assign Staff',
  'siteDetail.selectStaff': 'Select Staff',
  'siteDetail.selectStaffToAssign': 'Select staff to assign',
  'siteDetail.assignStaffWarning': 'Some staff could not be assigned: {staff_ids}',
  'siteDetail.assignStaffSuccess': 'Successfully assigned {mapped_staff_count} staff members',
  'siteDetail.assignStaffError': 'Failed to assign staff',
  'siteDetail.fetchStaffListError': 'Failed to fetch staff list',
  'siteDetail.loading': 'Loading...',
  'siteDetail.employeeID': 'Employee ID',
  'siteDetail.type': 'Type',
  'siteDetail.complain': 'Complain',
  'siteDetail.deletePhoneTitle': 'Delete Phone',
  'siteDetail.deletePhoneConfirm': 'Are you sure you want to delete this phone number?',
  'siteDetail.fetchPreferencesError': 'Failed to fetch preferences',
  'siteDetail.preferencesUpdatedSuccess': 'Preferences updated successfully',
  'siteDetail.preferencesUpdateFailed': 'Failed to update preferences',
  'siteDetail.preferenceRemovedSuccess': 'Preference removed successfully',
  'siteDetail.preferenceRemoveFailed': 'Failed to remove preference',
  'siteDetail.assignStaffWarning': 'Please select staff to assign',
  'siteDetail.assignStaffSuccess': 'Staff assigned successfully',
  'siteDetail.assignStaffError': 'Failed to assign staff',
  'siteDetail.deleteUnitTitle': 'Delete Unit',
  'siteDetail.deleteUnitConfirm': 'Are you sure you want to delete this unit?',
  'siteDetail.patrolRouteCreated': 'Patrol route created successfully',
  'siteDetail.patrolRouteUpdated': 'Patrol route updated successfully',
  'siteDetail.patrolRouteSaveFailed': 'Failed to save patrol route',
  'siteDetail.deletePatrolRouteTitle': 'Delete Patrol Route',
  'siteDetail.deletePatrolRouteConfirm': 'Are you sure you want to delete this patrol route?',
  'siteDetail.patrolRouteDeleted': 'Patrol route deleted successfully',
  'siteDetail.patrolRouteDeleteFailed': 'Failed to delete patrol route',
  'siteDetail.fetchPatrolRouteCheckpointsError': 'Failed to fetch patrol route checkpoints',
  'siteDetail.accessDenied': 'Access denied',
  'siteDetail.editShiftTitle': 'Edit Shift',
  'siteDetail.editPhoneTitle': 'Edit Phone',
  'siteDetail.updateLogTitle': 'Update Log',
  'unitModal.editTitle': 'Edit Unit',
  'unitModal.addTitle': 'Add New Unit',
  'unitModal.unitNumber': 'Unit Number',
  'unitModal.occupied': 'Occupied',
  'unitModal.availableTenants': 'Available Tenants',
  'unitModal.assignedTenants': 'Assigned Tenants',
  'unitModal.tenantName': 'Tenant Name',
  'unitModal.phoneNumber': 'Phone Number',
  'unitModal.leaseStart': 'Lease Start',
  'unitModal.leaseEnd': 'Lease End',
  'unitModal.createTenant': 'Create Tenant',
  'unitModal.fetchUnitTenantsError': 'Failed to fetch unit tenants',
  'unitModal.fetchAllTenantsError': 'Failed to fetch all tenants',
  'unitModal.createTenantSuccess': 'Tenant created successfully',
  'unitModal.createTenantError': 'Failed to create tenant',
  'welcome.learnMore': 'Learn more',
  'welcome.shiftAttendanceToday': "Today's Shift Attendance",
  'welcome.site': 'Site',
  'welcome.siteShortName': 'Short Name',
  'welcome.shift': 'Shift',
  'welcome.staff': 'Staff',
  'welcome.shiftStart': 'Shift Start',
  'welcome.attendance': 'Attendance',
  'welcome.checkedInAt': 'Checked in at {time}',
  'welcome.noAttendanceLate': 'No attendance (late)',
  'welcome.noAttendance': 'No attendance',
  'welcome.latestUnclosedIncidents': 'Latest Unclosed Incidents',
  'welcome.totalUnclosed': 'Total unclosed: {count}',
  'welcome.low': 'Low: {count}',
  'welcome.medium': 'Medium: {count}',
  'welcome.high': 'High: {count}',
  'welcome.title': 'Title',
  'welcome.severity': 'Severity',
  'welcome.state': 'State',
  'welcome.createdAt': 'Created At',
  'welcome.loggedBy': 'Logged By',
  'siteManagement.title': 'Site Management',
  'siteManagement.content': 'Manage all sites, including creation, editing, and searching.',
  'siteManagement.addNewSite': 'Add New Site',
  'siteManagement.siteList': 'Site List',
  'siteManagement.name': 'Name',
  'siteManagement.shortName': 'Short Name',
  'siteManagement.address': 'Address',
  'siteManagement.region': 'Region',
  'siteManagement.district': 'District',
  'siteManagement.status': 'Status',
  'siteManagement.active': 'Active',
  'siteManagement.inactive': 'Inactive',
  'siteManagement.shifts': 'Shifts',
  'siteManagement.action': 'Action',
  'siteManagement.edit': 'Edit',
  'siteManagement.viewDetails': 'View Details',
  'siteManagement.addSite': 'Add Site',
  'siteManagement.editSite': 'Edit Site',
  'siteManagement.siteName': 'Site Name',
  'siteManagement.pleaseEnterSiteName': 'Please enter the site name',
  'siteManagement.pleaseEnterShortName': 'Please enter the short name',
  'siteManagement.shortNameMax': 'Short name cannot exceed 10 characters',
  'siteManagement.shortNameTooltip': 'Short name for quick reference, max 10 characters',
  'siteManagement.pleaseEnterAddress': 'Please enter the address',
  'siteManagement.pleaseSelectRegion': 'Please select a region',
  'siteManagement.pleaseSelectDistrict': 'Please select a district',
  'siteManagement.searchName': 'Search by name',
  'siteManagement.searchShortName': 'Search by short name',
  'siteManagement.searchAddress': 'Search by address',
  'siteManagement.createSuccess': 'Site created successfully',
  'siteManagement.updateSuccess': 'Site updated successfully',
  'siteManagement.operationFailed': 'Operation failed',
  'siteManagement.showing': 'Showing',
  'siteManagement.of': 'of',
  'siteManagement.items': 'items',
  'siteManagement.shiftCalendar': 'Shift Calendar',
  'siteManagement.viewShiftCalendar': 'View Shift Calendar',
  'siteDetail.addUnit': 'Add Unit',
  'siteDetail.editUnit': 'Edit Unit',
  'siteDetail.deleteUnit': 'Delete Unit',
  'siteDetail.occupied': 'Occupied',
  'siteDetail.vacant': 'Vacant',
  'siteDetail.addShift': 'Add Shift',
  'siteDetail.addCheckpoint': 'Add Checkpoint',
  'siteDetail.addPhone': 'Add Phone',
  'siteDetail.addLog': 'Add Log',
  'siteDetail.edit': 'Edit',
  'siteDetail.delete': 'Delete',
  'siteDetail.yes': 'Yes',
  'siteDetail.no': 'No',
  'siteDetail.action': 'Action',
  'siteDetail.referenceCode': 'Reference Code',
  'siteDetail.activeLabel': 'Active',
  'siteDetail.inactiveLabel': 'Inactive',
  'siteDetail.occupiedLabel': 'Occupied',
  'siteDetail.vacantLabel': 'Vacant',
  'siteDetail.addNewShift': 'Add New Shift',
  'siteDetail.addNewPhone': 'Add New Phone',
  'siteDetail.addNewLog': 'Add New Log',
  'siteDetail.addNewUnit': 'Add New Unit',
  'siteDetail.addNewCheckpoint': 'Add New Checkpoint',
  'siteDetail.editCheckpointTitle': 'Edit Checkpoint',
  'siteDetail.editUnitTitle': 'Edit Unit',
  'siteDetail.deleteConfirm': 'Are you sure you want to delete this item?',
  'siteDetail.saveSuccess': 'Saved successfully',
  'siteDetail.saveFailed': 'Failed to save',
  'siteDetail.deleteSuccess': 'Deleted successfully',
  'siteDetail.deleteFailed': 'Failed to delete',
  'siteDetail.addResponse': 'Add Response',
  'siteDetail.updateResponse': 'Update Response',
  'siteDetail.cancel': 'Cancel',
  'siteDetail.pleaseEnter': 'Please enter',
  'siteDetail.pleaseSelect': 'Please select',
  'staffLeave.title': 'Staff Leave Management',
  'staffLeave.headerTitle': 'Leave Records',
  'staffLeave.employeeId': 'Employee ID',
  'staffLeave.staffName': 'Staff Name',
  'staffLeave.phone': 'Phone',
  'staffLeave.leaveType': 'Leave Type',
  'staffLeave.reason': 'Reason',
  'staffLeave.date': 'Date',
  'staffLeave.status': 'Status',
  'staffLeave.approvedBy': 'Approved By',
  'staffLeave.approvedAt': 'Approved At',
  'staffLeave.actions': 'Actions',
  'staffLeave.approveConfirm': 'Approve this leave?',
  'staffLeave.rejectConfirm': 'Reject this leave?',
  'staffLeave.approved': 'Approved',
  'staffLeave.pending': 'Pending',
  'staffLeave.rejected': 'Rejected',
  'staffLeave.approveSuccess': 'Leave approved',
  'staffLeave.rejectSuccess': 'Leave rejected',
  'staffLeave.updateFailed': 'Failed to update leave',
  'staffLeave.searchEmployeeId': 'Search employee ID',
  'staffLeave.searchName': 'Search name',
  'staffLeave.searchPhone': 'Search phone',
  'leave.annual': 'Annual Leave',
  'leave.sick': 'Sick Leave',
  'leave.personal': 'Personal Leave',
  'leave.other': 'Other',
  'userManagement.title': 'User Management',
  'userManagement.content': 'Manage user accounts and their status',
  'userManagement.userList': 'User List',
  'userManagement.createNewUser': 'Create New User',
  'userManagement.editUser': 'Edit User',
  'userManagement.createUser': 'Create User',
  'userManagement.resetPassword': 'Reset Password',
  'userManagement.username': 'Username',
  'userManagement.email': 'Email',
  'userManagement.role': 'Role',
  'userManagement.status': 'Status',
  'userManagement.active': 'Active',
  'userManagement.inactive': 'Inactive',
  'userManagement.createdAt': 'Created At',
  'userManagement.lastLogin': 'Last Login',
  'userManagement.actions': 'Actions',
  'userManagement.newPassword': 'New Password',
  'userManagement.searchUsername': 'Search username',
  'userManagement.searchEmail': 'Search email',
  'userManagement.pleaseInputUsername': 'Please input the username!',
  'userManagement.pleaseInputEmail': 'Please input the email!',
  'userManagement.password': 'Password',
  'userManagement.pleaseInputPassword': 'Please input the password!',
  'userManagement.leaveEmptyToKeepCurrent': 'Leave empty to keep current password',
  'userManagement.pleaseSelectRole': 'Please select a role!',
  'userManagement.pleaseInputNewPassword': 'Please input the new password!',
  'userManagement.userUpdated': 'User updated successfully',
  'userManagement.userCreated': 'User created successfully',
  'userManagement.saveUserFailed': 'Failed to save user',
  'transaction.title': 'Transactions',
  'transaction.create': 'Create Transaction',
  'transaction.edit': 'Edit Transaction',
  'transaction.description': 'Description',
  'transaction.amount': 'Amount',
  'transaction.currency': 'Currency',
  'transaction.category': 'Category',
  'transaction.unit': 'Unit',
  'transaction.status': 'Status',
  'transaction.transactionDate': 'Transaction Date',
  'transaction.attachment': 'Attachment',
  'transaction.createdAt': 'Created At',
  'transaction.actions': 'Actions',
  'transaction.referenceType': 'Reference Type',
  'transaction.referenceId': 'Reference ID',
  'transaction.protected': 'Protected',
  'transaction.uploadImage': 'Upload Image',
  'transaction.selectCategory': 'Select Category',
  'transaction.selectUnit': 'Select Unit',
  'transaction.descriptionRequired': 'Please enter description',
  'transaction.amountRequired': 'Please enter amount',
  'transaction.createSuccess': 'Transaction created successfully',
  'transaction.updateSuccess': 'Transaction updated successfully',
  'transaction.operationFailed': 'Transaction operation failed',
  'transaction.createTitle': 'Create Transaction',
  'transaction.editTitle': 'Edit Transaction',
  'transaction.income': 'Income',
  'transaction.expense': 'Expense',
  'transaction.status.pending': 'Pending',
  'transaction.status.approved': 'Approved',
  'transaction.status.rejected': 'Rejected',
  'transaction.status.cancelled': 'Cancelled',
  'transaction.categoryRequired': 'Please select a category',
  'transaction.deleteSuccess': 'Transaction deleted successfully!',
  'transaction.deleteFailed': 'Failed to delete transaction',
  'transaction.deleteConfirm': 'Are you sure to delete this transaction?',
  'transaction.yes': 'Yes',
  'transaction.no': 'No',
  'userManagement.passwordResetSuccess': 'Password has been reset successfully',
  'userManagement.passwordResetFailed': 'Failed to reset password',
  'userManagement.updateStatusFailed': 'Failed to update user status',
  'userManagement.fetchRolesFailed': 'Failed to fetch roles',
  'userManagement.accessDenied': 'Access Denied',
  'userManagement.oneTimePassword': 'One-Time Password',
  'userManagement.faceRecognition': 'Face Recognition',
  'userManagement.fetchTokensFailed': 'Failed to fetch tokens',
  'userManagement.tokenCreated': 'Token created successfully',
  'userManagement.createTokenFailed': 'Failed to create token',
  'userManagement.copiedToClipboard': 'Copied to clipboard',
  'userManagement.copyFailed': 'Failed to copy',
  'userManagement.tokenUpdated': 'Token updated successfully',
  'userManagement.updateTokenFailed': 'Failed to update token',
  'userManagement.tokenActivated': 'Token activated successfully',
  'userManagement.tokenDeactivated': 'Token deactivated successfully',
  'userManagement.tokenStatusToggleFailed': 'Failed to update token status',
  'userManagement.qrCodeGenerationFailed': 'Failed to generate QR code',
  'userManagement.oneTimePasswordTitle': 'One-Time Password Management',
  'userManagement.tokenDescription': 'Token Description',
  'userManagement.tokenDescriptionPlaceholder': 'Enter token description (optional)',
  'userManagement.expiresInHours': 'Expires in (hours)',
  'userManagement.createToken': 'Create Token',
  'userManagement.newTokenCreated': 'New token created',
  'userManagement.copy': 'Copy',
  'userManagement.tokenWarning': 'Please save this token as it will only be shown once!',
  'userManagement.token': 'Token',
  'userManagement.description': 'Description',
  'userManagement.noDescription': 'No description',
  'userManagement.used': 'Used',
  'userManagement.expired': 'Expired',
  'userManagement.valid': 'Valid',
  'userManagement.expiresAt': 'Expires At',
  'userManagement.usedAt': 'Used At',
  'userManagement.copyToken': 'Copy Token',
  'userManagement.qrCode': 'QR Code',
  'userManagement.generateQRCode': 'Generate QR Code',
  'userManagement.qrCodeTitle': 'QR Code - One-Time Token',
  'userManagement.download': 'Download',
  'userManagement.print': 'Print',
  'userManagement.close': 'Close',
  'userManagement.authenticationURL': 'Authentication URL',
  'userManagement.requestBody': 'Request Body',
  'userManagement.tokenInfo': 'Token Information',
  'userManagement.qrCodeInstructions': 'Scan this QR code to authenticate with the one-time token',
  'staffManagement.title': 'Staff Management',
  'staffManagement.staffList': 'Staff List',
  'staffManagement.addStaff': 'Add Staff',
  'staffManagement.editStaff': 'Edit Staff',
  'staffManagement.employeeId': 'Employee ID',
  'staffManagement.name': 'Name',
  'staffManagement.lastName': 'Last Name',
  'staffManagement.gender': 'Gender',
  'staffManagement.phone': 'Phone',
  'staffManagement.site': 'Site',
  'staffManagement.status': 'Status',
  'staffManagement.action': 'Action',
  'staffManagement.active': 'Active',
  'staffManagement.inactive': 'Inactive',
  'staffManagement.firstName': 'First Name',
  'staffManagement.titleLabel': 'Title',
  'staffManagement.mr': 'Mr.',
  'staffManagement.mrs': 'Mrs.',
  'staffManagement.ms': 'Ms.',
  'staffManagement.dr': 'Dr.',
  'staffManagement.dateOfBirth': 'Date of Birth',
  'staffManagement.address': 'Address',
  'staffManagement.emergencyContact': 'Emergency Contact',
  'staffManagement.emergencyPhone': 'Emergency Phone',
  'staffManagement.pleaseInputEmployeeId': 'Please input the employee ID!',
  'staffManagement.pleaseInputFirstName': 'Please input the first name!',
  'staffManagement.pleaseInputLastName': 'Please input the last name!',
  'staffManagement.pleaseSelectGender': 'Please select the gender!',
  'staffManagement.pleaseInputPhone': 'Please input the phone number!',
  'staffManagement.pleaseInputAddress': 'Please input the address!',
  'staffManagement.pleaseInputEmergencyContact': 'Please input the emergency contact!',
  'staffManagement.pleaseInputEmergencyPhone': 'Please input the emergency phone!',
  'staffManagement.staffCreated': 'Staff created successfully',
  'staffManagement.staffUpdated': 'Staff updated successfully',
  'staffManagement.operationFailed': 'Operation failed',
  'staffManagement.accessDenied': 'Access Denied',
  'staffManagement.searchEmployeeId': 'Search employee ID',
  'staffManagement.searchFirstName': 'Search first name',
  'staffManagement.searchLastName': 'Search last name',
  'staffManagement.searchPhone': 'Search phone',
  'staffManagement.filterBySite': 'Filter by site',
  'staffManagement.male': 'Male',
  'staffManagement.female': 'Female',
  'staffManagement.other': 'Other',
  'dashboard.siteAttendanceSummary': 'Site Attendance Summary',
  'dashboard.date': 'Date',
  'dashboard.selectDate': 'Select Date',
  'dashboard.attendance': 'Attendance',
  'dashboard.obRecords': 'OB Records',
  'dashboard.patrolRoutes': 'Patrol Routes',
  'dashboard.completed': 'Completed',
  'dashboard.pending': 'Pending',
  'dashboard.total': 'Total',
  'dashboard.noSites': 'No sites found',
  'dashboard.loading': 'Loading attendance data...',
  'dashboard.noSitesDesc': 'Try selecting a different date or check your site configuration',
  'dashboard.refresh': 'Refresh',
  'dashboard.unknownDistrict': 'Unknown District',
  'dashboard.unknownRegion': 'Unknown Region',
  'dashboard.noData': 'No data',
  'dashboard.byDistrict': 'By District',
  'dashboard.byRegion': 'By Region',
};
